// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchRecentItemsParams = {
    authToken: string,
    deployment: string,
};

export default {
    fetchRecentItems: ({ authToken, deployment }: FetchRecentItemsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<STATS-API>recent' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
